import React from "react";

function BS4_Images() {
  return (
    <div>
      <h1>BS4_Images Component</h1>
      <p>This is the BS4_Images tutorial page content.</p>
    </div>
  );
}

export default BS4_Images;
